import React from 'react';
import { ContentPage, MainContent, Sidebar } from "../ViewComponents";
import { VerticalSpacer } from '@shared/ui/atoms/VerticalSpacer';
import { selectedRootOffice, selectIsOfficeListLoading } from "../../../../store/officeView.duck";
import { useSelector } from "react-redux";
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import { OfficeViewDateWrapper } from "../OfficeViewDateWrapper";
import { selectIsOfficeUsageLoading } from "../../../../store/officeUsage.duck";
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { Center } from '@shared/ui/atoms/StructuralLayout';
import { OfficeUsageView } from "./OfficeUsageView";
import { OfficeListSidebar } from "./OfficeListSidebar";
import { tablet } from '@shared/ui/atoms/MediaQueries';
import { selectActiveDay } from "../../../../store/editMovements.duck";
import {
  DailyResponsibilityContentCards
} from '@shared/ui/organisms/responsibilitiesIndicator/DailyResponsibilityContentCards';
import { DownloadDailyCarParkReportButton } from '@shared/ui/molecules/DownloadDailyCarParkReportButton';
import { DownloadDailyOfficeReportButton } from '@shared/ui/molecules/DownloadDailyOfficeReportButton';
import Layout from '@shared/ui/organisms/layout/Layout';
import { BiggerThanTabletOnly } from '@shared/ui/atoms/DeviceSpecific';
import { WithDefaultOfficeSelection } from "@shared/hooks/WithDefaultOfficeSelection";
import { DailyOfficeVisitors } from '@shared/ui/organisms/visitor-booking/DailyOfficeVisitors';

export function DailyOfficeListView() {
  const isLoading = useSelector(selectIsOfficeListLoading);
  const isSavingMovements = useSelector(selectIsOfficeUsageLoading);
  const activeDay = useSelector(selectActiveDay);
  const activeOffice = useSelector(selectedRootOffice);


  WithDefaultOfficeSelection(true);

  return (
    <Layout>
      <DailyOfficeListViewContainer>
        <DailyOfficeListViewContent>
          <OfficeViewDateWrapper>
            {isSavingMovements && <Center><LoadingSpinner fullScreen={true} /></Center>}
            <OfficeContainer>
              {isLoading ? <LoadingSpinner hideBorder={true} style={{alignSelf: 'center', justifySelf: 'center'}}/> : <>
                <OfficeUsageView />
              </>}
            </OfficeContainer>
          </OfficeViewDateWrapper>
        </DailyOfficeListViewContent>
        <VerticalSpacer/>
        <Sidebar>
          <BiggerThanTabletOnly>
            <OfficeListSidebar />
          </BiggerThanTabletOnly>
          <DailyOfficeVisitors office={activeOffice} date={activeDay} />
          <DailyResponsibilityContentCards office={activeOffice} date={activeDay} />
          <DownloadDailyOfficeReportButton />
          <DownloadDailyCarParkReportButton />
        </Sidebar>
      </DailyOfficeListViewContainer>
    </Layout>
  )
}

const OfficeContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 500px;
  background-color: ${Colours.veryLightGrey};
`

const DailyOfficeListViewContainer = styled(ContentPage)`
  flex-direction: column;
  @media (${tablet}) {
    flex-direction: row;
  }
`

const DailyOfficeListViewContent = styled(MainContent)`
  padding-top: 0;
`
